import { css, html } from "lit";
import { property, query, customElement } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import SlDialog from "@shoelace-style/shoelace/dist/components/dialog/dialog";
import { FormsT } from "../form/FormTypes";
import { LightTheme } from "../ThemeLight";

import "../EntryDialog";

export function showFormEntryDialog(props: any, approved: any, cancelled: any = () => {}) {
    const dialog = Object.assign(document.createElement("ds-form-entry-dialog"), props);
    dialog.addEventListener("on-approved", (object: any) => {
        approved(object);
    });
    dialog.addEventListener("on-cancel", () => {
        cancelled();
    });
    document.body.append(dialog);
}

@customElement("ds-form-entry-dialog")
export class FormEntryDialog extends BaseElement {
    static override styles = [Style, LightTheme, css``];

    @property({ type: Boolean }) open = false;
    @property({ type: String }) label = "";
    @property({ type: Boolean }) noHeader: any;
    @property({ type: Boolean }) isValid = false;
    @property({ type: String }) acceptText = "Accept";
    @property({ type: String }) cancelText = "Cancel";
    @property({ type: Object }) object: any;
    @property({ type: Array }) fields: FormsT[] = [];

    @query("#dialog") _dialog: SlDialog | undefined;

    public show() {
        this._dialog?.show();
    }

    private hide() {
        this._dialog?.hide();
    }

    protected override firstUpdated(): void {
        if (this.open) {
            this.show();
        }
    }
    protected cancel() {
        this.dispatchEvent(
            new CustomEvent("on-cancel", {
                bubbles: true,
                composed: true,
                detail: {},
            })
        );
        this.hide();
    }

    override render() {
        return html`<ds-entry-dialog
            id="dialog"
            ?open=${this.open}
            .label=${this.label}
            ?noHeader=${this.noHeader}
            ?isValid=${this.isValid}
            @on-accept=${(e: CustomEvent) => {
                this._raiseEvent("on-approved", this.object);
                e.stopPropagation();
            }}
        >
            <ds-form
                .fields=${this.fields}
                .object=${this.object}
                @ds-form-changed=${(e: any) => {
                    this.isValid = e.detail.object.name !== "";
                }}
            >
            </ds-form>
        </ds-entry-dialog>`;
    }
}
